import * as tslib_1 from "tslib";
import { DirectionalShadowMapper } from "./DirectionalShadowMapper";
var NearDirectionalShadowMapper = (function (_super) {
    tslib_1.__extends(NearDirectionalShadowMapper, _super);
    function NearDirectionalShadowMapper(coverageRatio) {
        if (coverageRatio === void 0) { coverageRatio = .5; }
        var _this = _super.call(this) || this;
        _this.coverageRatio = coverageRatio;
        return _this;
    }
    Object.defineProperty(NearDirectionalShadowMapper.prototype, "coverageRatio", {
        /**
         * A value between 0 and 1 to indicate the ratio of the view frustum that needs to be covered by the shadow map.
         */
        get: function () {
            return this._coverageRatio;
        },
        set: function (value) {
            if (value > 1)
                value = 1;
            else if (value < 0)
                value = 0;
            this._coverageRatio = value;
        },
        enumerable: true,
        configurable: true
    });
    NearDirectionalShadowMapper.prototype._updateDepthProjection = function (projection) {
        var corners = projection.frustumCorners;
        for (var i = 0; i < 12; ++i) {
            var v = corners[i];
            this._localFrustum[i] = v;
            this._localFrustum[i + 12] = v + (corners[i + 12] - v) * this._coverageRatio;
        }
        this._updateProjectionFromFrustumCorners(projection, this._localFrustum, this._matrix);
        this._overallDepthProjection.frustumMatrix3D = this._matrix;
    };
    return NearDirectionalShadowMapper;
}(DirectionalShadowMapper));
export { NearDirectionalShadowMapper };



// WEBPACK FOOTER //
// ../dist/lib/shadowmappers/NearDirectionalShadowMapper.js